import { render, staticRenderFns } from "./ContactsFragmentDesktopPhoneList.vue?vue&type=template&id=5b87e8b0&"
import script from "./ContactsFragmentDesktopPhoneList.vue?vue&type=script&lang=js&"
export * from "./ContactsFragmentDesktopPhoneList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports